import { ProfileColor } from "../../ProfileColor";
import { Checkbox, DataSource, DateRangeFilter, Label, Layout, Panel, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOrderPlanningProfile extends Layout {
    checkboxExcludeOrderCompanies: Checkbox;
    checkboxExcludeOrderCustomer: Checkbox;
    checkboxExcludeOrderDriverMgr: Checkbox;
    checkboxExcludeOrderFleet: Checkbox;
    checkboxExcludeOrderIb: Checkbox;
    checkboxExcludeOrderLateStatus: Checkbox;
    checkboxExcludeOrderOb: Checkbox;
    checkboxExcludeOrderRespCode: Checkbox;
    checkboxExcludeOrderTrlrType: Checkbox;
    checkboxExcludeOrderType: Checkbox;
    checkboxExcludeRevCode: Checkbox;
    checkboxExcludeTractorCompanies: Checkbox;
    checkboxExcludeTractorCustomer: Checkbox;
    checkboxExcludeTractorDriverMgr: Checkbox;
    checkboxExcludeTractorFleet: Checkbox;
    checkboxExcludeTractorIb: Checkbox;
    checkboxExcludeTractorLateStatus: Checkbox;
    checkboxExcludeTractorOb: Checkbox;
    checkboxExcludeTractorRespCode: Checkbox;
    checkboxExcludeTractorTrlrType: Checkbox;
    checkboxExcludeTractorType: Checkbox;
    dateRangeFilter: DateRangeFilter;
    daterangefilterCalendarDates: DateRangeFilter;
    labelLabel1: Label;
    labelMiles: Label;
    layoutProfileColor: ProfileColor;
    panelExcludeMiles: Panel;
    panelGeneral: Panel;
    panelMovementOptions: Panel;
    panelMovements: Panel;
    panelOrderOptions: Panel;
    panelOrders: Panel;
    panelVisualPlanner: Panel;
    sourceOrderPlanningProfile: DataSource;
    switchAvailTractor: Switch;
    switchIncludeIAVLnHoldOrders: Switch;
    switchIncludeIPOnHoldOrders: Switch;
    switchIncludeOnHoldManifest: Switch;
    switchIncludeReserved: Switch;
    switchLocalTractor: Switch;
    switchOrderIncludeAccepted: Switch;
    switchOrderLateOnly: Switch;
    switchPreassOrder: Switch;
    switchPreassTractor: Switch;
    switchShowLtlOrders: Switch;
    switchUsePreassignDest: Switch;
    tabAvailable: Tab;
    tabGeneral: Tab;
    tabInProgress: Tab;
    tabTabVisualPlanner: Tab;
    tabsetPlanningProfile: Tabset;
    textboxCalendarZoomWeb: Textbox;
    textboxDefaultView: Textbox;
    textboxDriverActiveStatus: Textbox;
    textboxDriverManager: Textbox;
    textboxExcludeMiles: Textbox;
    textboxId: Textbox;
    textboxOrderCompanies: Textbox;
    textboxOrderCustomers: Textbox;
    textboxOrderDriverManager: Textbox;
    textboxOrderIbType: Textbox;
    textboxOrderIbZones: Textbox;
    textboxOrderLateStatus: Textbox;
    textboxOrderObType: Textbox;
    textboxOrderObZones: Textbox;
    textboxOrderRespCodes: Textbox;
    textboxOrderRespLevel: Textbox;
    textboxOrderTractorFleetId: Textbox;
    textboxOrderTrlrType: Textbox;
    textboxOrderType: Textbox;
    textboxRevenueCode: Textbox;
    textboxShowBrokerMoves: Textbox;
    textboxShowTeams: Textbox;
    textboxTitle: Textbox;
    textboxTractorCompanies: Textbox;
    textboxTractorCustomers: Textbox;
    textboxTractorDays: Textbox;
    textboxTractorFleet: Textbox;
    textboxTractorIbType: Textbox;
    textboxTractorIbZones: Textbox;
    textboxTractorLateOor: Textbox;
    textboxTractorLatestatus: Textbox;
    textboxTractorObType: Textbox;
    textboxTractorObZones: Textbox;
    textboxTractorOrDriver: Textbox;
    textboxTractorRespCodes: Textbox;
    textboxTractorRespLevel: Textbox;
    textboxTractorTrlrType: Textbox;
    textboxTractorTypes: Textbox;
}
